<template>
	<Loader v-if="loading" />
	<div v-else class="content">
		<h1>Move renewals</h1>

    <Modal
      v-if="open"
      v-on:close="open = null">

      <div
        class="margin-bottom">
        We can at most move <strong>{{ max }} subscriptions</strong> from {{ open.date }} to {{ move_date }} in
        <Flag
          style="display: inline-block; vertical-align: middle;"
          :localeid="open.locale" />
      </div>

      <div class="flex small-margin-bottom">
        <div
          class="margin-right">
          <div
            style="margin-bottom: 6px;">Move</div>
          <input
            v-model="move_count"
            type="number"
            :min="1"
            :max="max"
            />
        </div>
        <div
          class="margin-right">
          <div
            style="margin-bottom: 6px;">to</div>
          <input
            v-model="move_date"
            type="date"
            />
        </div>
        <div>
          <div
            style="margin-bottom: 6px;">&nbsp;</div>
          <button
            class="small"
            :disabled="saving"
            v-on:click="move">Move now</button>
        </div>
      </div>

      <div
        v-if="move_count < max"
        style="background: rgba(80, 80, 200, 0.1); padding: 15px; border-radius: 6px; font-size: 14px;">
        You can add another {{ max - move_count }} to the pool - <span class="link bold" v-on:click="move_count = max">do it now</span>
      </div>

      <table>
        <thead>
          <tr>
            <th></th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="subscription in getSubscriptions">
            <td
              v-on:click="info(subscription)">
              {{ subscription.id }}
            </td>
            <td>
              <span
                class="green"
                v-if="subscription._accepted">Moves to {{ move_date }}</span>
              <span
                style="color: #888"
                v-else-if="subscription._moveable">
                  Moveable, but not included
              </span>
              <span
                class="error"
                v-else-if="isInFuture(subscription._earliest_move_date, move_date)">
                Cannot be earlier than {{ subscription._earliest_move_date }}
              </span>
            </td>
          </tr>
        </tbody>
      </table>

      <button
        class="margin-top"
        :disabled="saving"
        v-on:click="move">Move now</button>

    </Modal>

    <div
      class="small-margin-top margin-bottom">
        <input
          type="date"
          v-model="request.from"
          />
        <input
          type="date"
          v-model="request.to"
          class="xs-margin-left"
          />
        <button
          class="small gray xs-margin-left"
          v-on:click="load"
          :disabled="loading"
          >Go</button>
    </div>

		<div class="margin-top">
      <table>
        <thead>
          <tr>
            <th></th>
            <th
              v-for="cid in getCountries">
              <Flag
                :countryid="cid" />
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(record, date) in getOverview">
            <td>{{ date }}</td>
            <td
              :width="200"
              v-for="cid in getCountries">
              <div
                class="number"
                v-on:click="openDate(date, cid, record[cid])"
                v-bind:class="{
                  disabled: ! record[cid].total,
                }">
                <template v-if="record[cid].total">
                  <div class="count">{{ record[cid].total }}</div>
                  <!-- <div class="count">{{ record[cid].moveable }}</div> -->
                  <!-- <div class="of">of {{ record[cid].total }}</div> -->
                </template>
                <template v-else>
                  0
                </template>
              </div>
            </td>
          </tr>
        </tbody>
			</table>
		</div>
	</div>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'

export default {
  data: () => ({
    loading: false,
    saving: false,
    data: [],
    request: {
      from: null,
      to: null
    },
    move_date: null,
    move_count: 1,
    open: null
  }),
  computed: {
    max () {
      const max = this.getSubscriptions.filter(row => row._moveable).length
      // let max = this.getSubscriptions.length

      // if (this.move_count > max) {
      //   this.move_count = max
      // }

      return max
    },
    getCountries () {
      return [1, 2, 3, 4]
    },
    getSubscriptions () {
      var list = []

      if (!this.open) {
        return list
      }

      var acceptedCounter = 0

      for (var i in this.data[this.open.date]) {
        const subscription = this.data[this.open.date][i]

        subscription._accepted = false

        if (subscription._locale_id == this.open.locale) {
          subscription._moveable = this.computeMoveable(subscription)

          if (
            subscription._moveable &&
            acceptedCounter < this.move_count
          ) {
            subscription._accepted = true
            acceptedCounter++
          }

          list.push(subscription)
        }
      }

      return list
    },
    getOverview () {
      var list = {}

      for (var date in this.data) {
        list[date] = this.getBasicRecord()

        for (var i in this.data[date]) {
          const subscription = this.data[date][i]

          list[date][subscription._locale_id].total++

          if (subscription._moveable) {
            list[date][subscription._locale_id].moveable++
          }
        }
      }

      return list
    }
  },
  watch: {
    max (value) {
      if (this.move_count > value) {
        this.move_count = value
      }
    }
  },
  methods: {
    info (subscription) {
      console.log(subscription)
    },
    computeMoveable (subscription) {
      // if (subscription._by_customer) {
      //   return false
      // }

      // if (subscription._has_recent_orders) {
      //   return false
      // }

      return !this.isInFuture(
        subscription._earliest_move_date,
        this.move_date
      )
    },
    isInFuture (date, from) {
      return date > Vue.$create.dateTime(from).format('Y-m-d')
    },
    openDate (date, locale, record) {
      if (!record.total) {
        return
      }

      this.open = {
        date: date,
        locale: locale,
        moveable: record.moveable,
        total: record.total
      }

      this.move_count = record.moveable
      this.move_date = Vue.$create.dateTime(date).addDays(2).format('Y-m-d')
    },
    getBasicRecord () {
      const basic = {}

      for (var cid of this.getCountries) {
        basic[cid] = {
          moveable: 0,
          total: 0
        }
      }

      return basic
    },
    move () {
      var subscriptions = []
      for (var subscription of this.getSubscriptions) {
        if (subscription._accepted) {
          subscriptions.push(subscription.id)
        }
      }

      Vue.$api.post('/new-subscriptions/move-renewals', {
        ids: subscriptions,
        to: this.move_date
      }, {
        before: () => this.saving = true,
        always: () => this.saving = false,
        callback: data => this.afterMove(data)
      })
    },
    afterMove (data) {
      this.open = null

      this.load()
    },
    load () {
      const url = '/new-subscriptions/move-renewals?from={from}&to={to}'
        .replace('{from}', this.request.from)
        .replace('{to}', this.request.to)

      Vue.$api.get(url, {}, {
        before: () => this.loading = true,
        always: () => this.loading = false,
        callback: data => this.parse(data)
      })
    },
    parse (data) {
      for (var r in data) {
        for (var i in data[r]) {
          if (data[r][i]._earliest_move_date) {
            const new_date = Vue.$create.dateTime(data[r][i]._earliest_move_date).addDays(10).format('Y-m-d')
            data[r][i]._earliest_move_date = new_date
          }
        }
      }

      this.data = data
    }
  },
  created () {
    var date = Vue.$create.dateTime(new Date())

    this.request.from = date.format('Y-m-d')
    this.request.to = date.addDays(30).format('Y-m-d')

    this.load()
  }
}
</script>

<style lang="less" scoped>
  .number {
    display: flex;
    cursor: pointer;
    .of {
      position: relative;
      top: 13px;
      padding-bottom: 13px;
      margin-left: 6px;
      color: #555;
      font-size: 13px;
    }
    .count {
      position: relative;
      font-size: 16px;
      font-weight: 400;
      &::after {
        transition: 200ms;
        content: "";
        position: absolute;
        width: 36px;
        height: 36px;
        left: ~"calc(50% - 18px)";
        top: ~"calc(50% - 18px)";
        transform: scale(0, 0);
        background: rgba(50, 50, 200, 0.2);
        border-radius: 50%;
      }
    }
    &:hover {
      .count::after {
        transform: none;
      }
    }
    &.disabled {
      cursor: not-allowed;
      opacity: 0.25;
    }
  }
</style>
